<script lang="ts">
  import type { UserNotification } from "$types";
  import { createEventDispatcher } from "svelte";
  import { onMount } from "svelte";
  import NotificationIcons from "./notification_parts/NotificationIcons.svelte";
  import NotificationText from "./notification_parts/NotificationText.svelte";

  export let index: number;
  export let notification: UserNotification;

  const dispatch = createEventDispatcher();

  let hover: boolean = false;
  let alerted = true;

  onMount(() => {
    setTimeout(() => {
      alerted = false;
    }, 2000);
  });
</script>

<a
  class:alerted
  href={notification.link}
  class="notification"
  on:click={() => dispatch("clicked", { index })}
  on:mouseenter={() => (hover = true)}
  on:mouseleave={() => (hover = false)}
>
  <NotificationIcons {notification} {hover} />
  <NotificationText {notification} {hover} />
</a>

<style>
  a {
    display: flex;
    width: 100%;
    border-bottom: 1px dashed var(--dots);
    gap: 0.5rem;
    font-family: "Open Sans";
    text-decoration: none;
    align-items: center;
    background: white;
    transition: background 1s ease;
    padding: 0.25rem;
    border-radius: 0.25rem;
  }
  a.alerted {
    background: var(--dots);
  }
  a:last-of-type {
    border-bottom: none;
  }
</style>
